export const GET_WISHLIST_ITEMS = 'GET_WISHLIST_ITEMS';
export const GET_WISHLIST_ITEMS_SUCCESS = 'GET_WISHLIST_ITEMS_SUCCESS';

export const GET_WISHLIST_ITEM_BY_ID = 'GET_WISHLIST_ITEM_BY_ID';
export const GET_WISHLIST_ITEM_BY_ID_SUCCESS = 'GET_WISHLIST_ITEM_BY_ID_SUCCESS';

/** The caller's own requests TherapyLake updated since they last opened them — the sidebar red dot. */
export const GET_WISHLIST_UPDATES_COUNT = 'GET_WISHLIST_UPDATES_COUNT';
export const GET_WISHLIST_UPDATES_COUNT_SUCCESS = 'GET_WISHLIST_UPDATES_COUNT_SUCCESS';
/** The requester opened a request — clear its red dot. */
export const MARK_WISHLIST_SEEN = 'MARK_WISHLIST_SEEN';

export const CREATE_WISHLIST_ITEM = 'CREATE_WISHLIST_ITEM';
export const EDIT_WISHLIST_ITEM = 'EDIT_WISHLIST_ITEM';
export const DELETE_WISHLIST_ITEM = 'DELETE_WISHLIST_ITEM';

/** Not a request — dispatched as a success so App.js shows the "comment posted" toast. */
export const WISHLIST_COMMENT_POSTED = 'WISHLIST_COMMENT_POSTED';
